import { useContext } from 'react';

import { WizardStateContext } from './WizardStateContext';

/**
 * Spec 026 — convenience hook for the Wizard-State-Context.
 *
 * Throws if used outside `<WizardStateProvider>`. The provider is mounted
 * inside `<AuthProvider>` and outside `<Routes>` in `App.tsx`.
 */
export function useWizardState() {
  const ctx = useContext(WizardStateContext);
  if (!ctx) {
    throw new Error(
      'useWizardState must be used within a <WizardStateProvider>',
    );
  }
  return ctx;
}
